export default "__VITE_ASSET__ee095c57__"